import { MSG_ERRO_SERVIDOR } from '../../shared/constantes/mensagens';


const INITIAL_STATE = {
    esperandoSolicitacao: false,
    vinculos: null,
    error: false,
    mensagem: '',    
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case 'DECLARACAO_VINCULOS_RECEBIDO':            
            return { ...state, esperandoSolicitacao: false, error: false, mensagem: '', vinculos: action.payload };

        case 'DECLARACAO_IMPRESSAO_RECEBIDA':
            return { ...state, esperandoSolicitacao: false, mensagem: 'sucesso' };

        case 'DECLARACAO_IMPRESSAO_SOLICITADA':
            return { ...state, esperandoSolicitacao: true, mensagem: '' };   
        
        case 'DADOS_VINCULOS_SOLICITADOS':
            return { ...state, esperandoSolicitacao: true, mensagem: '' };   

        case 'DECLARACAO_ERRO_IMPRESSAO_RECEBIDO':
            return { ...state, esperandoSolicitacao: false, mensagem: (action.payload) ? action.payload : MSG_ERRO_SERVIDOR, error: true };
    
        case 'DECLARACAO_ERRO_VINCULOS_RECEBIDO':
            return { ...state, esperandoSolicitacao: false, mensagem: 'erro_vinculos', error: true };    

        case 'DECLARACAO_LIMPAR_MENSAGEM':
            return { ...state, esperandoSolicitacao: true, error: false, mensagem: '' };

        case 'VOLTA_HOME_PPP':
            return { ...state, esperandoSolicitacao: false, error: false, mensagem: '' };

        case 'DECLARACAO_NAO_ENCONTRADA':
            return { ...state, esperandoSolicitacao: false, error: true, mensagem: 'not_found' };

        case 'DECLARACAO_NOVA_SOCLICITACAO':
            return { ...state, esperandoSolicitacao: false, error: false, mensagem: '' };
        
        case 'DECLARACAO_SEM_VICULOS_PPP':
            return { ...state, esperandoSolicitacao: false, error: true, mensagem: 'sem_vinculos_ppp' };

        default:
            return state;
    }
}
